import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { BaseDTO, DTOField } from './BaseDTO';
import { CreativeFormatDTO } from './CreativeFormatDTO';


export class CreativeDTO extends BaseDTO {
    fields: DTOField[] = [
        {
            name: 'creativeId',
            type: 'number'
        },
        {
            name: 'name',
            type: 'string',
            validators: [Validators.required]
        },
        {
            name: 'type',
            type: 'string'
        },
        {
            name: 'adDuration',
            type: 'number',
            validators: [Validators.required]
        },
        {
            name: 'language',
            type: 'number',
            validators: [Validators.required]
        },
        {
            name: 'creativeAuthor',
            type: 'string'
        },
        {
            name: 'creativeFormats',
            type: 'formArray',
            arrayClass: CreativeFormatDTO,
            createInitialItem: true
        },
        {
            name: 'creative_product_id',
            type: 'number'
        }
    ];

    constructor(fb?: FormBuilder) {
        super(fb);
        if (fb) {
            this.init();
        }
    }
}
